import { render, staticRenderFns } from "./WaterPressureCard.vue?vue&type=template&id=65b42d2a&scoped=true&"
import script from "./WaterPressureCard.vue?vue&type=script&lang=js&"
export * from "./WaterPressureCard.vue?vue&type=script&lang=js&"
import style0 from "./WaterPressureCard.vue?vue&type=style&index=0&id=65b42d2a&lang=scss&scoped=true&"
import style1 from "./WaterPressureCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b42d2a",
  null
  
)

export default component.exports